import './style.scss';
import noUiSlider from '../../../js/libs/nouislider'
import {getWord} from '../../../js/utils/wordEnding';

export default !function () {
  const block = document.querySelector('.learning-profit');

  if (!block) {
    return;
  }

  const slider = block.querySelector('.learning-profit__slider');

  const rangeStart = Number(slider.dataset.rangeStart);
  const rangeEnd = Number(slider.dataset.rangeEnd);
  const rangeMiddle = (rangeEnd + rangeStart) / 2; // середина по значениям слайдера
  const rangeMiddleVisual = Number(slider.dataset.rangeMiddle); // середина для визуала

  const gradeName = block.querySelector('.learning-profit__grade-name');
  const profitTimeDisplay = block.querySelector('.learning-profit__duration-value')
  const coursePrice = slider.dataset.coursePrice;

  let currency = slider.dataset.currency;
  const gradations = JSON.parse(slider.dataset.gradations)

  const rangeGlassesStart = rangeEnd * 0.97; // после 97% начинаем показывать очки

  slider.style.setProperty('--glasses-opacity', 0);

  const setGradeName = (value) => {
    if (value === rangeEnd) {
      gradeName.textContent = gradations[2];
    } else if (value > rangeMiddle) {
      gradeName.textContent = gradations[1];
    } else {
      gradeName.textContent = gradations[0];
    }
  }

  const setProfitTime = (value) => {
    const profitTime = Math.ceil(coursePrice / value);

    profitTimeDisplay.textContent = `за ${profitTime} ${getWord('month', profitTime)}`;
  }

  /* рассчитываем визуальное значение зп для тултипа
  * расчет таким образом:
  * (сумма на ближайшем визуальном делении слева
  * + (текущее значение - реальное значение на ближайшем визуальном делении слева))
  * * коэффицент */
  const recalc = (value) => {
    value = Math.ceil(value);

    let coef;
    let delta;
    let result;

    if (value < rangeMiddle) {
      coef = (rangeMiddleVisual - rangeStart) / (rangeMiddle - rangeStart);
      delta = (value - rangeStart) * coef;
      result =  Math.ceil(rangeStart + delta);
    } else {
      coef = (rangeEnd - rangeMiddleVisual) / (rangeEnd - rangeMiddle);
      delta = (value - rangeMiddle) * coef;
      result =  Math.ceil(rangeMiddleVisual + delta);
    }

    result = Math.ceil(result / 1000) * 1000; // округляем до 1000

    setProfitTime(result);

    return result;
  };

  noUiSlider.create(slider, {
    start: rangeStart,
    range: {
      'min': rangeStart,
      'max': rangeEnd
    },
    pips: false,
    format: {
      to: function (value) {
        return value.toFixed();
      },
      // по дефолту нужна, без нее ломается
      from: function (value) {
        return Number(value);
      }
    },
    tooltips: {
      to: function (value) {
        return `${recalc(value).toLocaleString('ru-RU')} ${currency}`;
      }
    },
    connect: [true, false],
    orientation: "horizontal",
  });

  slider.noUiSlider.on('slide', function ([value]) {
    value = Number(value);

    setGradeName(value);

    if (Number(value) > rangeMiddle) {
      slider.classList.add('learning-profit__slider--middle');
      slider.classList.remove('learning-profit__slider--min');
    } else {
      slider.classList.add('learning-profit__slider--min');
      slider.classList.remove('learning-profit__slider--middle');
    }

    if (value > rangeGlassesStart) {
      const delta = rangeEnd - rangeGlassesStart;
      const opacity = 1 - ((rangeEnd - value) / delta);

      slider.style.setProperty('--glasses-opacity', opacity);
      slider.classList.add('learning-profit__slider--max');
    } else {
      slider.style.setProperty('--glasses-opacity', 0);
      slider.classList.remove('learning-profit__slider--max');
    }
  });

  slider.noUiSlider.on('change', function ([value]) {
    value = `${recalc(Number(value)).toLocaleString('ru-RU')} ${currency}`;

    window.$analytics?.push('learning-profit-slider-change', {
      value
    });
  });
}();
